// extracted by mini-css-extract-plugin
export var aboveInput = "_ny-0";
export var actionButton = "_ny-5";
export var actionButtonContainer = "_ny-1";
export var actionIcon = "_ny-6";
export var aiInfoContainer = "_ny-2";
export var attachmentWrapper = "_ny-7";
export var bold = "_ny-3";
export var checkIcon = "_ny-8";
export var clickingRecipientBar = "_ny-11";
export var commentThreadSwitch = "_ny-a";
export var draftImage = "_ny-b";
export var draftImageContainer = "_ny-c";
export var draftImages = "_ny-e";
export var editButton = "_ny-g";
export var editor = "_ny-f";
export var editorContainer = "_ny-y";
export var editorErrorTooltipWrapper = "_ny-9";
export var headerDivider = "_ny-h";
export var icon = "_ny-i";
export var info = "_ny-j";
export var internal = "_ny-n";
export var internalDivider = "_ny-k";
export var internalMessage = "_ny-l";
export var messageInputCard = "_ny-m";
export var messageInputForm = "_ny-o";
export var messageInputFormInternal = "_ny-p";
export var options = "_ny-q";
export var publicMessageCustomer = "_ny-s";
export var publicMessageMerchant = "_ny-r";
export var removeImageButton = "_ny-d";
export var replyButtons = "_ny-t";
export var showSignatureButton = "_ny-u";
export var spinner = "_ny-v";
export var verticalButtonDivider = "_ny-4";
export var visibilitySelector = "_ny-w";
export var warning = "_ny-x";
export var wrappingText = "_ny-z";
export var writingInternalNoteTopBorder = "_ny-10";